export enum LoadingState {
  Waiting = 'waiting',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}
